// extracted by mini-css-extract-plugin
export default {"video-modal":"video-modal--3YWRU","video-modal__title":"video-modal__title--1U8Wy","video-modal__video-container":"video-modal__video-container--3rrIL","video-modal__text":"video-modal__text--bdMjw"};
    if(module.hot) {
      // 1747648148346
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  